// extracted by mini-css-extract-plugin
export default {"main":"Main_main__yowlL","section":"Main_section__7Ih7p"};